import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import DoctorActivities from "../../DoctorDashboard/doctor-activities";
import DoctorProfile from "../../DoctorDashboard/doctor-profile";
import MessageBox from "../../UI Component/StarRating/MessageBox";
import StarRating from "../../UI Component/StarRating/StarRating";
import StarRatingTicker from "../../UI Component/StarRating/StarRatingTicker";
import { isMobile } from "react-device-detect";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";

const MyProfileContent = (props) => {
  const {
    showRatingPopup,
    callLastConsultationFeedback,
    setCallLastConsultationFeedback,
  } = props;
  // Doctor Profile State
  const [cookies] = useCookies(["cookie-name"]);
  const [profile, setProfile] = useState({
    prefix_name: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    specialization: "",
    short_url_slug: "",
    is_partial_doctor: "false",
    doctor_onboard_link: "",
    onboarding_form_completed: "",
  });

  const [doctorFullName, setDoctorFullName] = useState("");

  // Next Appointment State
  const nextAppointment = {
    patient_name: "",
    id: "", // appointment id
    appointment_id: "",
    appointment_date: "",
    start_time: "",
    end_time: "",
    // below properties are required for video consultation page
    patient_dob: "",
    appointment_end_date_time: "",
    first_name: "",
    last_name: "",
    degree: "",
    phone_no: "",
    patient_city: "",
  };

  const [checkLastConsultationFeedback, setCheckLastConsultationFeedback] =
    useState("");
  const [feedbackProvided, setFeedbackProvided] = useState(true);
  const [feedbackStatus, setFeedbackStatus] = useState(false);
  const [tickerAnimate, setTickerAnimate] = useState(true);
  const [feedbackAppoinmentId, setFeedbackAppoinmentId] = useState(null);
  const [feedbackSuccessStatus, setFeedbackSuccessStatus] = useState(false);
  const [newRating, setNewRating] = useState(null);
  const [providerType, setProviderType] = useState(1);

  let is_staff = localStorage.getItem("user_type");
  let userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  let openStarRatingPopups = localStorage.getItem("openStarRatingPopups");

  // Set Doctor Full Name
  useEffect(() => {
    let fullName =
      (profile?.prefix_name ? profile?.prefix_name : "") +
      (profile?.first_name ? " " + profile?.first_name : "") +
      (profile?.middle_name ? " " + profile?.middle_name : "") +
      (profile?.last_name ? " " + profile?.last_name : "");
    setDoctorFullName(fullName);
  }, [profile]);

  // get privious rating status
  useEffect(() => {
    fetchPreviousRatingStatus();
  }, []);

  // useEffect to show the rating popup after ending the call from the next appointment card

  useEffect(() => {
    if (showRatingPopup) {
      setFeedbackStatus(true);
    }
  }, [showRatingPopup]);

  useEffect(() => {
    if (callLastConsultationFeedback) {
      setFeedbackAppoinmentId(localStorage.getItem("qualaroo_appointment_id"));
      fetchPreviousRatingStatus();
      setCallLastConsultationFeedback(false);
    }
  }, [callLastConsultationFeedback]);

  function fetchPreviousRatingStatus() {
    afterLoginApiAxios
      .post(
        "/doctor/check-last-consultation-feedback",
        { user_id: userId ? userId : cookies?.user_id },
        // { upcoming: true },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token")
              ? localStorage.getItem("id_token")
              : cookies?.id_token,
          },
        }
      )
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setCheckLastConsultationFeedback(response.data.data);
          if (openStarRatingPopups) {
            setFeedbackProvided(true);
            setFeedbackStatus(true);
            setFeedbackAppoinmentId(
              localStorage.getItem("qualaroo_appointment_id")
            );
          } else {
            setFeedbackProvided(response.data.feedback_provided);
          }
        }
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  }

  // Callback to get doctor profile data
  function profileCallback(p) {
    setProfile(p);
  }

  const ratingChanged = (newRating) => {
    setNewRating(newRating);
    callStarRating();
  };

  const callStarRating = () => {
    setProviderType(1);
    setFeedbackStatus(true);
    setTickerAnimate(false);
    setFeedbackAppoinmentId(checkLastConsultationFeedback.appointment_id);
  };

  const closeTicker = () => {
    setTickerAnimate(false);
  };

  const onCancelFeedback = () => {
    setFeedbackStatus(false);
    setFeedbackAppoinmentId(null);
    setFeedbackSuccessStatus(false);
    window.location.href = "/clinic/account/dashboard";
    localStorage.removeItem("qualaroo_appointment_id");
    localStorage.removeItem("openStarRatingPopups");
  };

  const onSuccessFeedback = (
    starRating,
    starRatingAudio,
    starRatingVideo,
    starRatingRx,
    starRatingConsultation,
    starRatingEaseOfBooking,
    feedback
  ) => {
    if (starRating) {
      afterLoginApiAxios
        .post(
          "/user/add-rating-feedback",
          {
            provider_id: userId,
            provider_type: 1,
            rating_point: starRating,
            feedback_message: feedback,
            action_on_item_id: feedbackAppoinmentId,
            appointment_id: checkLastConsultationFeedback.appointment_id,
            action_on_item_type: "consultation",
            source: isMobile ? "mobile view" : "desktop",
            audio_quality: starRatingAudio,
            video_quality: starRatingVideo,
            rx_generation: starRatingRx,
            consultation_joining: starRatingConsultation,
            booking_payment: starRatingEaseOfBooking,
          },
          {
            headers: {
              Authorization: localStorage.getItem("id_token"),
            },
          }
        )
        .then((res) => {
          if (
            res?.data &&
            res?.data?.statusCode &&
            res?.data?.statusCode === 200
          ) {
            localStorage.removeItem("openStarRatingPopups");
            setFeedbackStatus(false);
            setFeedbackSuccessStatus(true);
          }
        })
        .catch((err) => C2CConsole.error(err));
    }
  };

  return (
    <>
      <div className="p-2">
        <DoctorProfile
          parentCallback={profileCallback}
          nextAppointment={nextAppointment}
          callNextAppointmentWidget={props?.callNextAppointmentWidget}
        />
        {profile?.is_partial_doctor &&
        profile?.is_partial_doctor.toLowerCase() === "false" ? (
          <DoctorActivities
            slugUrl={profile?.short_url_slug}
            doctorFullName={doctorFullName}
          />
        ) : (
          ""
        )}
      </div>
      <>
        {is_staff === "doctor" ? (
          feedbackProvided ? (
            ""
          ) : (
            <StarRatingTicker
              checkLastConsultationFeedback={checkLastConsultationFeedback}
              callStarRating={callStarRating}
              closeTicker={closeTicker}
              ratingChanged={ratingChanged}
              tickerAnimate={tickerAnimate}
              newRating={newRating}
            />
          )
        ) : (
          ""
        )}
      </>
      <>
        {feedbackStatus ? (
          <StarRating
            successHandler={onSuccessFeedback}
            closeHandler={onCancelFeedback}
            show={feedbackStatus}
            provider_type={providerType}
            newRating={newRating}
          />
        ) : (
          ""
        )}
        {feedbackSuccessStatus ? (
          <MessageBox
            successHandler={onCancelFeedback}
            closeHandler={onCancelFeedback}
            show={feedbackSuccessStatus}
          />
        ) : (
          ""
        )}
      </>
    </>
  );
};

export default MyProfileContent;
